module.exports = __webpack_public_path__ + "img/sad-smile.791e25b7.svg";